{
  "settings": {
    "sections": {
      "booking": {
        "label": "Online booking",
        "hint": "Patients booking you themselves, and your days off, at each clinic"
      }
    },
    "onlineBooking": {
      "regionLabel": "Online booking at your clinics",
      "cardSubtitle": "Patients booking themselves in the patient app and on your page",
      "unnamedClinic": "Unnamed clinic",
      "loadFailed": "Online booking settings are not available.",
      "saved": "Online booking setting saved.",
      "saveFailed": "The setting was not saved. Please try again.",
      "allow": {
        "label": "Patients can book online themselves",
        "impact": "When off, no online times are shown for you at this clinic in the patient app or on your page. Bookings by the front desk are not affected."
      },
      "horizon": {
        "label": "Up to how many days ahead",
        "unit": "days",
        "placeholder": "The clinic's limit",
        "clinicCap": "Clinic limit: {{days}} days",
        "effective": "Patients can now book up to {{days}} days ahead.",
        "effectiveNone": "With the clinic's current limit, patients cannot book online for now.",
        "capped": "Your number is above the clinic's limit, so the clinic's {{days}} days apply.",
        "paused": "Your online booking at this clinic is paused.",
        "invalid": "Enter a number from 1 to 365, or leave it empty to use the clinic's limit."
      },
      "warnings": {
        "noPresence": "Your hours at this clinic are not registered, so no online booking is shown.",
        "noPresenceHint": "The clinic's front desk registers your hours.",
        "clinicClosed": "This clinic is not taking online bookings from patients right now.",
        "clinicClosedHint": "Your setting applies once the clinic turns online booking on."
      },
      "empty": {
        "title": "You are not a member of any clinic",
        "hint": "Online booking is set for clinics where your membership has been accepted.",
        "action": "Go to clinics"
      },
      "daysOff": {
        "title": "Days off",
        "hint": "On these days neither patients nor the front desk can book you at this clinic. Appointments already booked are not changed.",
        "add": "Add a day off",
        "empty": "No upcoming days off.",
        "emptyHint": "Record the days you are away — travel, a congress, illness.",
        "loadFailed": "Days off are not available.",
        "wholeDay": "All day",
        "hours": "{{start}} to {{end}}",
        "range": "{{from}} to {{to}}",
        "remove": "Remove",
        "removeAria": "Remove the day off {{range}}",
        "removeTitle": "Remove day off",
        "removeBody": "Remove the day off {{range}} at “{{clinic}}”? Once removed, you can be booked on these days again.",
        "removeConfirm": "Remove",
        "removed": "Day off removed.",
        "removeFailed": "The day off was not removed."
      },
      "dayOff": {
        "title": "Add a day off",
        "subtitle": "At “{{clinic}}”",
        "from": "From",
        "to": "To (optional)",
        "toHint": "Leave empty for that single day.",
        "span": "Length",
        "spanWhole": "All day",
        "spanPart": "Part of the day",
        "start": "From",
        "end": "Until",
        "partHint": "These hours apply on every day of the range.",
        "reason": "Reason (optional)",
        "reasonPlaceholder": "e.g. a congress",
        "submit": "Save day off",
        "saveFailed": "The day off was not saved.",
        "errors": {
          "from": "Choose the start date.",
          "order": "The end date cannot be before the start date.",
          "range": "A day off can be at most 366 days long.",
          "past": "A day off cannot end before today.",
          "hours": "The start time must be before the end time."
        }
      }
    }
  },
  "errors": {
    "bff": {
      "onboarding": {
        "clinicListUnavailable": "The list of clinics is not available."
      },
      "onlineBooking": {
        "notMember": "You are not an accepted member of this clinic.",
        "settingsLoad": "Online booking settings could not be loaded.",
        "settingsSave": "Online booking settings could not be saved.",
        "horizonInvalid": "The number of days must be from 1 to 365; leave it empty for the clinic's limit.",
        "invalid": "The details entered are not valid.",
        "daysOffLoad": "Days off could not be loaded.",
        "dayOffSave": "The day off could not be saved.",
        "dayOffRemove": "The day off could not be removed.",
        "dayOffNotFound": "This day off was not found.",
        "dayOffDate": "The date of the day off is not valid.",
        "dayOffOrder": "The end date of the day off cannot be before its start date.",
        "dayOffRange": "A day off can be at most 366 days long.",
        "dayOffPast": "A day off cannot end before today.",
        "dayOffMinutes": "The start time of the day off must be before its end time."
      }
    }
  }
}
